module.exports = __webpack_public_path__ + "static/fonts/Oswald-Medium.e0f21da.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Medium.ttf
// module id = lL8r
// module chunks = 1